import React, { Component } from 'react';
import { Redirect, withRouter, Link, Route, useLocation } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import OktaAuth from '@okta/okta-auth-js';

import pkceChallenge from 'pkce-challenge';
import WithTracker from './../../../../containers/App/WithTracker';

import FreeAccount from './../../payment/PricingCards/components/FreeAccount';

import TopBar from './../../TopBar'
import Footer from './../../Footer'
import { _axiosCall } from '../../../helpers/apicalls';
import axios from "axios";
import {
  Card, CardBody, Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Container, Badge, Collapse
} from 'reactstrap';
import{
	setLocalStorage,
	getLocalStorage
} from '../../../helpers/utils';

import{
	_getUserSSO,
	_setSSOToken,
	_getSSOToken
} from './ssoutils';


export default withRouter(class Login extends Component {
  constructor(props) {
	super(props);
	this.onSuccess = this.onSuccess.bind(this);
	this.onError = this.onError.bind(this);
	this.state = {
	  authenticated: null,
	  fetchInProgress: false,
	  authToken: false,
	  error: false,
	  errorMessage:false
	};

  }
  
  componentDidMount() {
	   if(window.location.href.indexOf('dashboard')>=0){
		   const codes = pkceChallenge();
		   sessionStorage.setItem('code_challenge', codes.code_challenge);
		   sessionStorage.setItem('code_verifier', codes.code_verifier);
		   const REALOGY_AUTH_URL = `${process.env.REALOGY_BASE_URL}authorize?client_id=${process.env.REALOGY_CLIENT_ID}&code_challenge=${codes.code_challenge}&code_challenge_method=S256&redirect_uri=${process.env.REALOGY_REDIRECT_URI}&response_mode=fragment&response_type=code&idp=${process.env.REALOGY_IDP}&state=testing&scope=openid email profile`;
		   
		   console.log(REALOGY_AUTH_URL);
		   window.location.href = REALOGY_AUTH_URL;
	   }else if(window.location.href.indexOf('sso')>=0){   
		   var hash = window.location.hash.substr(1);
		   
		   var hashObject = hash.split('&').reduce(function (res, item) {
			   var parts = item.split('=');
			   res[parts[0]] = parts[1];
			   return res;
		   }, {});
		   console.log(hashObject);
		   if(hashObject['error']){
			   this.setState({error:hashObject['error'], errorMessage: hashObject['error_description'] ? decodeURI(hashObject['error_description'].replace(/\+/g, " ")) : "Authorization failed, please contact your support team."})
		   }else{
			   this._getAuthToken(hashObject)
		   }
		   
		   
	   }else{
		  var hash = window.location.search.replace("?", "");
			  
		  var hashObject = hash.split('&').reduce(function (res, item) {
			  var parts = item.split('=');
			  res[parts[0]] = parts[1];
			  return res;
		  }, {});
		  console.log(hashObject);
		  if(hashObject['error']){
			  this.setState({error:hashObject['error'], errorMessage: hashObject['error_description'] ? decodeURI(hashObject['error_description'].replace(/\+/g, " ")) : "Authorization failed, please contact your support team."})
		  }
	   }
  }
  
  _getAuthToken = (hashObject) => {
	   // console.log('_getBuildingData called', this.state)
	   if (!this.state.fetchInProgress) {
			this.setState(prevState => ({ fetchInProgress: true, }));
		}
		
		const params = new URLSearchParams();
		params.append('client_id', process.env.REALOGY_CLIENT_ID);
		params.append('redirect_uri', process.env.REALOGY_REDIRECT_URI);
		params.append('grant_type', "authorization_code");
		params.append('code', hashObject.code);
		params.append('code_verifier', sessionStorage.getItem('code_verifier'));
		axios.post(`${process.env.REALOGY_BASE_URL}token`, params).then(token => {
			console.log(token.data.id_token);
			
			if(token.data && token.data.id_token){
				_setSSOToken(token.data);
				this.setState({authToken : token.data})
				
			}
			
			console.log(this._oktaAuth)
				
		})
		.catch(error => {
			console.log("error: " + error);
		});
		
	
	}

 
  onSuccess(res) {
	if (res.status === 'SUCCESS') {
	  return this.props.authService.redirect({
		sessionToken: res.session.token
	  });
   } else {
	
	}
  }

  onError(err) {
	console.log('error logging in', err);
  }

  render() {
	const { location } = this.props;
	const { authToken, error, errorMessage } = this.state;
	
	if(authToken){
		return <Redirect to={{ pathname: `/dashboard`}} />
	}
	if(window.location.href.indexOf('sso')>=0 && !error) return null;
	const isError = error;
	return (
		<div className="plan__wrapper share__wrapper">
			<TopBar goTo={'plans'} />
			<Row className="login-container login">
				<Col lg={12} className="pt-0 signin">
				<div className={"widget-container login cbwarburg"}>
				<div className={"sso-logo-container"}>
				  <div className={"sso-logo"} />
				</div>
				<h4 className="text-center mt-5 mb-2">
					Coldwell Banker Warburg Login
				</h4>
				
				<div className="sub-text">For CB Warburg users only, you will be redirected to sign in.</div>
				
				<Link className="mt-5 button" to={'/dashboard/cbwarburg'}>
					Sign In
				</Link>
				{isError &&
					<div className="sub-text mt-3" style={{color:"#F53246"}}>{errorMessage}</div>
				}
				<div className={'signin-toggle mt-5 '}>{`Not a CB Warburg user?`} <Link to={`/pricing`}>Sign Up</Link> or <Link to={`/login`}>Sign In</Link></div>
					  
				<p className="disclaimer">By signing in, you agree to our{` `}<a href="https://marketproof.com/terms-of-use" target="_blank">Terms of Service</a>{` `}and 
				{` `}<a href="https://marketproof.com/privacy-policy" target="_blank">Privacy Policy</a>.</p> 
				</div>
				  
					
				</Col>
			</Row>
			<Footer />
		</div>
	)
	
	  

		
  }
});